var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-core__header" },
    [_c("app-core-header-left"), _c("app-core-header-right")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }